import { useEffect, useState } from 'react';
import { FormControl, LinearProgress, MenuItem, TextField, type TextFieldProps } from '@mui/material';
import { getTodayEvents } from '../api/events';
import type { EventInfo } from '../api/types';

interface EventSelectorProps extends Omit<TextFieldProps, 'onChange'> {
    value: number | '';
    host?: string | number;
    onChange: (eventId: number) => void;
}

export function EventSelector({ value, host, onChange, ...props }: EventSelectorProps) {
    const [list, setList] = useState<EventInfo[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        setLoading(true);
        getTodayEvents(host)
            .then((events) => {
                if (active) setList(events);
            })
            .catch(() => {
                if (active) setList([]);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [host]);

    return (
        <FormControl fullWidth variant="filled">
            <TextField select fullWidth value={value} onChange={(e) => onChange(Number(e.target.value))} {...props}>
                {loading ? (
                    <MenuItem disabled>
                        <LinearProgress className="w-full" />
                    </MenuItem>
                ) : list.length === 0 ? (
                    <MenuItem disabled>Non ci sono eventi</MenuItem>
                ) : (
                    list.map((option) => (
                        <MenuItem key={option.event_id} value={option.event_id}>
                            {option.event_title}
                            {option.event_location ? ` — ${option.event_location}` : ''}
                        </MenuItem>
                    ))
                )}
            </TextField>
        </FormControl>
    );
}
